export function HomepageDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.HOMEPAGE + '/:param')
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'getLatestVersion': {
                method: 'GET',
                path: '/latestVersion'
            },
	        'getViolationsCount': {
		        method: 'GET',
		        params: {param: 'violationsCount'}
	        },
            'getIndexedUserPackages': {
                method: 'GET',
                params: {param: 'indexedUserPackages'}
            },
            'getInstancesCount': {
                method: 'GET',
                params: {param: 'instancescount'}
            },
            'getAlertsCount': {
                method: 'GET',
                params: {param: 'alertscount'}
            },
            'getCurrentVersion': {
                method: 'GET',
                params: {param: 'getXrayVersion'}
            }

        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/homepage_dao.js